const PREVIEW_ID_KEY = 'preview_id';

const readFromLocation = (): string | null => {
  const { search, hash } = window.location;

  const fromSearch = new URLSearchParams(search).get(PREVIEW_ID_KEY);
  if (fromSearch) return fromSearch;

  const hashBody = hash.replace(/^#/, '');
  const hashQuery = hashBody.includes('?') ? hashBody.slice(hashBody.indexOf('?') + 1) : hashBody;
  return new URLSearchParams(hashQuery).get(PREVIEW_ID_KEY);
};

export const getPreviewId = (): string | null => {
  const fromUrl = readFromLocation();

  if (fromUrl) {
    try {
      localStorage.setItem(PREVIEW_ID_KEY, fromUrl);
    } catch {}
    return fromUrl;
  }

  try {
    return localStorage.getItem(PREVIEW_ID_KEY);
  } catch {
    return null;
  }
};

export const appendPreviewId = (url: string): string => {
  const previewId = getPreviewId();
  if (!previewId) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${PREVIEW_ID_KEY}=${previewId}`;
};

export const isPreviewMode = (): boolean => Boolean(getPreviewId());
